import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface AssertivaCpfConsulta {
  id: string;
  created_at: string;
  resultado: { cabecalho?: Record<string, unknown>; resposta?: Record<string, unknown> } | null;
}

export interface AssertivaCpfFila {
  status: string;
  erro_mensagem: string | null;
  atualizado_em: string;
}

// Consulta única por CPF (Douglas 14/09/2026): lê a consulta paga original, nunca
// um registro de cache, e a posição na fila enquanto ela ainda não rodou.
export function useAssertivaCpf(cpf: string | null | undefined) {
  const documento = (cpf || '').replace(/\D/g, '');
  return useQuery({
    queryKey: ['assertiva-cpf', documento],
    enabled: documento.length === 11,
    staleTime: 60_000,
    queryFn: async (): Promise<{ consulta: AssertivaCpfConsulta | null; fila: AssertivaCpfFila | null }> => {
      const [consulta, fila] = await Promise.all([
        supabase.from('assertiva_consultas')
          .select('id, created_at, resultado')
          .eq('tipo_consulta', 'cpf').eq('chave_consulta', documento).eq('sucesso', true)
          .order('created_at', { ascending: true }).limit(1).maybeSingle(),
        supabase.from('assertiva_cpf_fila')
          .select('status, erro_mensagem, atualizado_em')
          .eq('cpf', documento).maybeSingle(),
      ]);
      if (consulta.error) throw consulta.error;
      return {
        consulta: (consulta.data as unknown as AssertivaCpfConsulta) || null,
        fila: fila.error ? null : ((fila.data as unknown as AssertivaCpfFila) || null),
      };
    },
  });
}
